import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { TranslationTag } from '../types/i18n';

const useVegasOverride = ({ vegas }: TranslationTag) => {
  const showVegasContent = useSelector(select.site.showVegasContent);

  return useMemo(() => {
    if (vegas && showVegasContent) {
      return { defaultMessage: vegas };
    }

    return {};
  }, [showVegasContent, vegas]);
};

export default useVegasOverride;
